import request from "@/utils/request";

const obj = {
    getDeviceByCode(code) {
        return request.get(`/device/deviceQRCode/agent/getDeviceByCode/${code}`)
    }
}
export default obj;
